import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react"; // Importing shopping cart icon
import book from '../../assets/images/book_1.png'

const PricingPlan = () => {
    return (
        <div className="lg:px-16 p-4 mx-auto  py-8">
            <div className=" bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="p-6">
                    <h1  style={{ fontFamily: "Helvetica" }} className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
                        Discover the ideas that have transformed leaders around the world.
                    </h1>
                    <p className="text-center text-gray-700 text-base mb-6">
                        This Executive Presence Assessment is built on the foundational principles from Coach Kshitij's book, 'Demystifying Executive Presence.'
                    </p>

                    <div className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8">
                        {/* Book Cover */}
                        <div className="w-full md:w-1/3 flex justify-center">
                            <a
                                href="https://www.amazon.in/dp/933408698X"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="transform transition-transform hover:scale-105"
                            >
                                <img
                                    // src="https://m.media-amazon.com/images/I/614-4tLImbL._SL1500_.jpg"
                                    src={book}
                                    alt="Book cover of 'Demystifying Executive Presence' by Kshitij Sharma"
                                    className="max-w-xs rounded-lg shadow-md"
                                />
                            </a>

                            {/* <div className="flex justify-center mt-6">
                                <a
                                    href="https://www.amazon.in/dp/933408698X"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors"
                                >
                                    <ShoppingCart className="mr-2" />
                                    Buy on Amazon
                                </a>
                            </div> */}
                        </div>

                        {/* Book Description and Testimonials */}
                        <div className="w-full md:w-2/3 space-y-4">
                            <p className="text-gray-700 leading-relaxed">
                                Delve into the core traits of effective leaders—such as communication, confidence, authenticity and more—this book offers the actionable insights that form the basis of a powerful Executive Presence.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Understand the 8 elements of Executive Presence * Unlock the secrets to effective authority & impact * Learn practical strategies to elevate your influence
                            </p>

                            {/* Amazon Purchase Button */}


                            <div className="space-y-4">
                                <h2  style={{ fontFamily: "Helvetica" }} className="text-lg font-bold text-gray-800">What readers are saying</h2>

                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <p className="font-semibold text-gray-800 mb-2">
                                        The perfect guidebook for executive presence
                                    </p>
                                    <p className="text-gray-600 italic">
                                        "I'm happy to see such a comprehensive book on executive presence. Kshitij has summarised his decades of experience here. This book will help executives at all levels to establish their presence and play the corporate game powerfully."
                                    </p>
                                </div>

                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <p className="font-semibold text-gray-800 mb-2">
                                        Simple and Practical - instant application of learning
                                    </p>
                                    <p className="text-gray-600 italic">
                                        "I love the simplicity and the approach taken to help understand executive presence. The story line kept me immersed chapter after chapter. I could relate to the examples and situation stated, making it real to day to day life."
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingPlan;